import Component from "../abstracts/Component";
import Bouncer from 'formbouncerjs';

export default class ContactUsComponent extends Component {
  get SELECTORS() {
    return {
      main: '#contactUsForm',
      subject: '.js-contact-subject',
      returns: '.js-subject-returns',
      orders: '.js-subject-orders',
      form: '.js-contact-form',
      blocks: '.js-subject',
      subjectCode: '.js-subject-code',
      contactUs: '.contactUsPageGReCaptchaChallange'
    }
  }

  constructor() {
    super();

    this.contactUsValidator = null;
  }

  submitForm(data, url) {
    return $.ajax({
      url: url,
      method: 'POST',
      data: data,
    });
  }

  showAdditionalData(index) {
    const ordersBlock = document.querySelector(this.SELECTORS.orders);
    const returnsBlock = document.querySelector(this.SELECTORS.returns);
    switch (index) {
      case 8:
        (ordersBlock ? ordersBlock.classList.add('d-none') : false);
        (returnsBlock ? returnsBlock.classList.remove('d-none') : false);
        break;
      case 2:
        (returnsBlock ? returnsBlock.classList.add('d-none') : false);
        (ordersBlock ? ordersBlock.classList.remove('d-none') : false);
        break;
      default:
        (ordersBlock ? ordersBlock.classList.add('d-none') : false);
        (returnsBlock ? returnsBlock.classList.add('d-none') : false);
    }
    document.querySelector(this.SELECTORS.subjectCode).value = index;
  }

  bindSubject() {
    this.$on('change', ({
      event
    }) => {

      let blocks = $(this.SELECTORS.main).find(this.SELECTORS.blocks);
      let index =  event.currentTarget[event.currentTarget.selectedIndex].getAttribute('data-subject-id');
      this.showAdditionalData(index);
      blocks.each(function () {
        let $input = $(this).find('input, select');
        if ($(this).hasClass('d-none')) {
          $input.prop('disabled', true);
        } else {
          $input.prop('disabled', false);
        }
      })

    }, 'body', this.SELECTORS.subject);
  }

  bindSubmit() {

    const form = $(this.SELECTORS.form),
      button = form.find('button[type="submit"]'),
      validators = form.find('[data-bouncer-message-missing-value]'),
      _this = this;

    // add error span for textarea
    var span = $('<span />').addClass('error-textarea');
    form.find('textarea').after(span);
    form.find('textarea').attr('data-bouncer-target', '.error-textarea');

    this.contactUsValidator = new Bouncer(this.SELECTORS.form, {
      customValidations: {
        select2: function (field) {

          const $el = $(field);
          if ($el.is('select')) {
            if (form.find('.error-select').length == 0) {
              var span1 = $('<span />').addClass('error-select');
              form.find('.select2').after(span1);
              $el.attr('data-bouncer-target', '.error-select');
            }
            // console.log($el.find(':selected')[0].index);

            if ($el.hasClass('js-contact-subject')) {
              if ($el.find(':selected')[0].index == 0) {
                $el.parent().find('.select2').addClass('select-error');
                return true;
              } else {
                $el.parent().find('.select2').removeClass('select-error');
                return false;
              }
            }
          }

        }
      },
      disableSubmit: true,
      emitEvents: true,
      messages: {
        missingValue: {
          default: validators.attr('data-bouncer-message-missing-value')
        },
        patternMismatch: {
          default: validators.attr('data-bouncer-message'),
          email: validators.attr('data-bouncer-message')
        }
      },
    });

    form.find('select').on('change.select2', function (e) {
      if (form.find('.error-select').length == 0) {
        var span1 = $('<span />').addClass('error-select');
        form.find('.select2').after(span1);
        form.find(e.currentTarget).attr('data-bouncer-target', '.error-select');
      }
      _this.contactUsValidator.validate(e.currentTarget);
    });

    // check form is not valid
    document.addEventListener('bouncerFormInvalid', function (event) {

      if (form.is(event.target)) {
        // console.log('form NON valido');
        button.attr('disabled', true);
      }

    }, false);

    // check form validated
    document.addEventListener('bouncerFormValid', function (event) {

      if (form.is(event.target)) {
        // console.log('form valido');
        button.removeAttr('disabled');

        if (!window.RecapchaComponent.getResponseFromWidget('contactUsPage')) {
          // User have not completed the challenge
          return;
        }

        if($(_this.SELECTORS.subject).find(':selected').data('subject-id') == 8) {
          if($("input[name='datePick']").val() == '') {
            $("input[name='datePick']").prop("disabled", true);
          }
        }

        var disabled = $('#contactUsForm').find('select:disabled').removeAttr('disabled');
        const serializedForm = form.serialize();
        disabled.attr('disabled','disabled');

        const action = form.attr('action');

        document.querySelector(_this.SELECTORS.contactUs).setAttribute('disabled', 'disabled');
        _this.submitForm(serializedForm, action).then(res => {
          form.parent().html(res);
          $(`${_this.SELECTORS.main} select`).select2({
            minimumResultsForSearch: Infinity,
            maximumSelectionLength: 10,
            width: 'style'
          });
        });

      }

    }, false);


    document.addEventListener('bouncerRemoveError', function (event) {

      if ($(event.target).closest(_this.SELECTORS.main).length) {
        // console.log('campo validato');
        let areValid = _this.contactUsValidator.validateAll(form[0]);
        if (areValid.length == 0) {
          button.removeAttr('disabled');
        }
      }

    }, false);

  }

  render() {
    this.log('rendering...');
    this.bindSubmit();
    if (document.querySelector(this.SELECTORS.returns) || document.querySelector(this.SELECTORS.orders)) {
      this.bindSubject();
      if($(this.SELECTORS.subject)) {
        $(this.SELECTORS.subject).trigger('change');
      }
    }
  }
}
